<template>
    <div>
        <div class="py-3">
            <BasicInfoHongkong
                class="block-item bg-grey2 p-3"
                :provinceOpt="provinceOpt"
                @file-uploaded = "fileUploaded"
                ref="basicInfo"
            ></BasicInfoHongkong>

            <RegisterInfoHongkong
                class="block-item bg-grey2 p-3"
                :provinceOpt="provinceOpt"
                :nationalityOpt="nationalityOpt"
                @file-uploaded = "fileUploaded"
                ref="registerInfoHongkong"
            ></RegisterInfoHongkong>

            <div class="mb-5 block-item bg-grey2 p-3">
                <div class="d-flex">
                    <h5>{{ $t('Director Information') }}</h5>
                </div>
                <hr>
                
                <div class="px-3 mb-3 mt-3">
                    <DirectorInfo
                        ref='directorInfo'
                        @file-uploaded = "fileUploaded"
                        :doc_type_list = document
                        :nationalityOpt = nationalityOpt
                        :provinceOpt="provinceOpt"
                        :is_remove = "director_list.length>1?true:false"
                    ></DirectorInfo>
                </div>
            </div>

            <div class="mb-3 block-item bg-grey2 p-3">
                <div class="d-flex">
                    <h5>{{ $t('Beneficiary Information') }}</h5>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup()">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'beneficiary'" v-if="showPopup"></NewPopupInfo>
                    </span>
                </div>
                <hr>
                
                <div class="px-3 mb-3 mt-3">
                    <div v-for="(item,index) in beneficary_list" :key="item.id">
                        
                        <BeneficiaryInfo 
                            :ref="'beneficiary'+item.id"
                            @file-uploaded = "fileUploaded"
                            :provinceOpt="provinceOpt"
                            :doc_type_list = document
                            :nationalityOpt = nationalityOpt
                            :is_remove = "beneficary_list.length>1?true:false"
                        ></BeneficiaryInfo>

                        <hr>
                        <div class="d-flex justify-content-end mb-2">
                            <div class="mb-0">
                                
                                <div class="w-100 ml-auto d-flex justify-content-end mb-3">
                                    <button v-if="beneficary_list.length>1" class="d-flex align-items-center btn btn-outline-red" @click="removeItem(item.id)">
                                        <span>Remove</span>
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-orange" @click="addBeneficiary">Add +</button>
                                </div>

                            </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div>

            <hr>
            <div  class="form-group text-justify">
                <label :for="agree" id="agree" class="d-flex align-items-start justify-content-center">
                    <input v-model="agree" type="checkbox" autocomplete="off" @change="onChange('agree')" class="mt-2">
                    <span class="ml-4 w-100 fz-14">
                        <p><i>{{ $t('agreement-1') }}</i></p>
                        <p><i>{{ $t('agreement-2') }}</i></p>
                        <p><i>{{ $t('agreement-3') }}</i></p>
                    </span>
                </label>
                <div v-if="error.agree" class="text-danger d-block">
                    {{$t(error.agree)}}
                </div>
            </div>
            
            <TakePicture :ref="'take-picture'" @take-photo="takePhoto($event)"></TakePicture>
        </div>
        <div class="text-right mt-3">
            <button class="btn btn-primary" @click="submitAccount">Submit</button>
        </div>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>

    import Select2 from 'v-select2-component';

    import FileUploader from '@/components/Kyc/FileUploader.vue';
    import TakePicture from "@/components/Kyc/TakePicture";
    import NewDocOption from "@/components/Kyc/NewDocOption";
    import BeneficiaryInfo from '@/components/CardManagement/beneficiaryInfo.vue';
    import BasicInfoHongkong from '@/components/CardManagement/basicInfoHongkong.vue';
    import DirectorInfo from '@/components/CardManagement/directorInfo.vue';

    import CreateAccount from '@/services/CreateAccount';
    import LoaderComponent from "@/components/LoaderComponent";
    import NewPopupInfo from '@/components/NewPopupInfo.vue';
    import RegisterInfoHongkong from '@/components/CardManagement/RegisterInfoHongkong.vue';

    import Vue from 'vue';

    export default {
        name: 'enterprises-hongkong',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                city_code:'',
                province_code:'',
                district_code:'',
                nationality:'',
                showPopup:false,
                agree:'',
                provinceOpt:[],
                nationalityOpt:[],
                beneficary_list:[{"id":1}],
                director_list:[{"id":1}],
                beneficary_data:[],
                director_data:[],
                isDisabled:false,
                isLoading:false,
                legal_personal_doc_type:0,
                document:[
                    {
                        "id":1,
                        "name":"Identity Card"
                    },
                    {
                        "id":2,
                        "name":"Passport"
                    }
                ],
                error:{
                    nationality:'',
                    agree:''
                }
            }
        },
        components: {
            TakePicture,
            FileUploader,
            LoaderComponent,
            Select2,
            NewDocOption,
            BeneficiaryInfo,
            BasicInfoHongkong,
            DirectorInfo,
            NewPopupInfo,
            RegisterInfoHongkong
        },
        methods:{
            onChange(name){
                this.error[name]="";
            },
            submitAccount(){
                let is_valid = true;
                let self = this;
                this.isLoading = true;

                if(!this.$refs['basicInfo'].validate()){
                    console.log("basic info belum valid");
                    is_valid = false;
                }

                if(!this.$refs['directorInfo'].validate()){
                    console.log("director belum valid");
                    is_valid = false;
                }
                

                if(!this.$refs['registerInfoHongkong'].validate()){
                    console.log("register info belum valid");
                    is_valid = false;
                }

                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    if(!this.$refs[ref][0].validate()){
                        console.log("beneficiary belum valid");
                        is_valid = false;
                    }
                }

                if(!this.agree){
                    is_valid = false;
                    console.log("agree belum valid");
                    this.error.agree = "must be checked";
                }

                if(is_valid){
                    CreateAccount.createType({"userType":3}).then(response => {
                        const data = response.data.data;
                        self.uploadPhoto(data);
                    }).catch(err => {
                        this.checkError(err);
                    });
                }
                else{
                    this.isLoading = false;
                }
            },
            uploadPhoto(account){
                console.log("=== account ===");
                console.log(account);
                this.account = account;

                this.$refs['basicInfo'].uploadFile(account);
                this.$refs['directorInfo'].uploadFile(account);
                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    this.$refs[ref][0].uploadFile(account);
                }
            },
            fileUploaded(){
                let beneficiary_completed = true;
                let have_failed = false;
                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    if(this.$refs[ref][0].success==null){
                        beneficiary_completed = false;
                        console.log("beneficiary complete false");
                    }
                    if(this.$refs[ref][0].success === false){
                        have_failed = true;
                        console.log("beneficiary have error");
                    }
                }

                if(
                    this.$refs['basicInfo'].success!=null &&
                    this.$refs['directorInfo'].success!=null && 
                    beneficiary_completed
                ){
                    if(
                        this.$refs['basicInfo'].success === false ||
                        this.$refs['directorInfo'].success === false || have_failed === true
                    ){
                        this.isLoading = false;
                    }
                    else if(
                        this.$refs['basicInfo'].success === true &&
                        this.$refs['directorInfo'].success === true && have_failed === false
                    ){
                        this.submitData();
                    }
                }
            },
            submitData(){

                let basic_info = this.$refs['basicInfo'];
                let register_info = this.$refs['registerInfoHongkong'];
                let director_info = this.$refs['directorInfo'];

                let params = {
                    "accountId":this.account.accountId,
                    "name":basic_info.params.name,
                    "enName":basic_info.params.enName,
                    "province":basic_info.params.province,
                    "city":basic_info.params.city,
                    "area":basic_info.params.area,
                    "address":basic_info.params.address,
                    "orgRegister":basic_info.file.orgRegister,
                    "orgRegisterNo" : basic_info.params.orgRegisterNo,
                    "declarationForm" : basic_info.file.declarationForm,
                    "incorporationForm" : basic_info.file.incorporationForm,
                    "businessRegister" : basic_info.file.businessRegister,
                    "businessRegisterExpiryDate" : basic_info.params.businessRegisterExpiryDate,
                    "businessRegisterNo" : basic_info.params.businessRegisterNo,
                    "stockCertificate" : basic_info.file.stockCertificate,
                    "registerDate":register_info.params.registerDate,
                    "registerAmt" : register_info.params.registerAmt,
                    "registerProvince" : register_info.params.registerProvince,
                    "registerCity" : register_info.params.registerCity,
                    "registerArea" : register_info.params.registerArea,
                    "registerAddress" : register_info.params.registerAddress,
                    "directorName":director_info.params.directorName,
                    "directorBirthDate":director_info.params.directorBirthDate,
                    "directorIdNo":director_info.params.directorIdNo,
                    "directorIdType":director_info.params.directorIdType,
                    "directorIdFront":director_info.file.directorIdFront,
                    "directorIdReverse":director_info.file.directorIdReverse,
                    "directorIdHold":director_info.file.directorIdHold,
                    "directorCertExpiryDate":director_info.params.directorCertExpiryDate,
                    "directorCountryCode":"HKG",
                    "directorProvince":director_info.params.directorProvince,
                    "directorCity":director_info.params.directorCity,
                    "directorArea":director_info.params.directorArea,
                    "directorAddress":director_info.params.directorAddress,
                    "beneficiaryIdFront":[],
                    "beneficiaryIdReverse":[],
                    "beneficiaryIdType":[],
                    "beneficiaryIdNo":[],
                    "beneficiaryName":[],
                    "beneficiaryBirthDate":[],
                    "beneficiaryCertExpiryDate":[],
                    "beneficiaryCountry":[],
                    "beneficiaryProvince":[],
                    "beneficiaryCity":[],
                    "beneficiaryArea":[],
                    "beneficiaryAddress":[],
                    "beneficiaryShareholderRatio":[],
                };

                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    params['beneficiaryIdFront'].push(this.$refs[ref][0].file.beneficiaryIdFront);
                    params['beneficiaryIdReverse'].push(this.$refs[ref][0].file.beneficiaryIdReverse);
                    params['beneficiaryIdType'].push(this.$refs[ref][0].params.beneficiaryIdType);
                    params['beneficiaryIdNo'].push(this.$refs[ref][0].params.beneficiaryIdNo);
                    params['beneficiaryName'].push(this.$refs[ref][0].params.beneficiaryName);
                    params['beneficiaryBirthDate'].push(this.$refs[ref][0].params.beneficiaryBirthDate);
                    params['beneficiaryCertExpiryDate'].push(this.$refs[ref][0].params.beneficiaryCertExpiryDate);
                    params['beneficiaryCountry'].push("HKG");
                    params['beneficiaryProvince'].push(this.$refs[ref][0].params.beneficiaryProvince);
                    params['beneficiaryCity'].push(this.$refs[ref][0].params.beneficiaryCity);
                    params['beneficiaryArea'].push(this.$refs[ref][0].params.beneficiaryArea);
                    params['beneficiaryAddress'].push(this.$refs[ref][0].params.beneficiaryAddress);
                    params['beneficiaryShareholderRatio'].push(this.$refs[ref][0].params.beneficiaryShareholderRatio);
                }

                console.log("=== parameter ===");
                console.log(params);

                CreateAccount.hongkong(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$swal({
                        icon: 'success',
                        title: 'success',
                        showConfirmButton: true,
                    }).then((result) => {
                        this.$router.push({ path: '/list-account' });
                    });
                }).catch(err => {
                    this.checkError(err);
                });

            },
            togglePopup(){
                this.showPopup=!this.showPopup;
            },
            addBeneficiary(){
                this.beneficary_list.push({"id":(this.beneficary_list[this.beneficary_list.length-1].id+1)});
            },
            addDirector(){
                this.director_list.push({"id":(this.director_list[this.director_list.length-1].id+1)});
            },
            selectedDocument(data){
                this.legal_personal_doc_type = data.index;
            },
            removeItem(id) {
                const index = this.beneficary_list.findIndex(item => item.id === id)
                if (index !== -1) {
                    this.beneficary_list.splice(index, 1)
                }
            },
            removeItemDirector(id) {
                const index = this.director_list.findIndex(item => item.id === id)
                if (index !== -1) {
                    this.director_list.splice(index, 1)
                }
            },
            doEscapeMarkup(markup){
                return markup;
            },
            removeImage($event){
                console.log($event);
            },
            captureFile($event) {
                console.log($event);
            },
            toggleCamera(current_take) {
                this.current_take = current_take;
                this.$refs['take-picture'].toggleCamera(current_take);
            },
            takePhoto($event){
               console.log($event);
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{

                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let basic_info = this.$refs['basicInfo'];
                                let register_info = this.$refs['registerInfoHongkong'];
                                let director_info = this.$refs['directorInfo'];

                                Object.keys(response.data.message).forEach((key) => {
                                    let error = response.data.message[key][0];
                                    
                                    if(typeof basic_info.error[key] !== "undefined"){
                                        basic_info.error[key] = error;
                                    }
                                    else if(typeof register_info.error[key] !== "undefined"){
                                        register_info.error[key] = error;
                                    }
                                    else if(typeof director_info.error[key] !== "undefined"){
                                        director_info.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });
                                

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                                
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            }
        },
        mounted(){
            CreateAccount.getProvince({"country":"HKG"}).then(response => {
                const data = response.data.data;
                this.provinceOpt = [];
                data.forEach(item => {
                    this.provinceOpt.push({"id":item.value,"text":item.text,"code":item.id});    
                });
            }).catch(err => {
                this.checkError(err);
            });
        }
    };
  </script>
